import styled from 'styled-components';

export const PageContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px;

    @media (min-width: 500px) {
        padding: 24px 48px;
    }

    @media (min-width: 768px) {
        padding: 24px 60px;
    }
`;
